(() => {
  const addToWishListTrigger = $("[data-wish-list-add]");
  const wishListCounter = $("[data-wish-list-counter]");
  const increaseCounter = () => {
    const counterValue = parseInt(wishListCounter.text());

    wishListCounter.text(counterValue + 1);
  };

  const addToWishList = event => {
    const productId = parseInt(
      $(event.currentTarget).attr("data-wish-list-add")
    );

    $.ajax({
      type: "POST",
      dataType: "json",
      url: myajax.ajaxurl,
      data: {
        action: "add_to_wish_list",
        productId
      },
      success(data) {
        const { status } = data;

        if (status) {
          increaseCounter();
        }
      }
    });
  };

  addToWishListTrigger.on("click", addToWishList);
})();
